<template>
  <Transition name="fade">
    <session class="mobile-page-backtotop" v-if="show" @click="Utils.mobileScrollToTop">
      <Icon name="backtotop" size="24" />
      <span>{{ LOCAL('backtotop') }}</span>
    </session>
  </Transition>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import Icon from '@/components/icon/index.vue';
  import * as Utils from '@/assets/utils';
  import { LOCAL } from '@/assets/lang';

  const show = ref(false);
  const showInit = () => {
    if(!Utils.isMobile()) return;

    window.addEventListener("scroll", function (e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      show.value = scrollTop > 100;
    })
  }
  onMounted(() => {
    showInit();
  });

</script>

<style scoped lang="less">
  @import "index.less";
</style>
